<template>
    <div class="block block-generic-text" ref="contentBlock">
        <div class="capper">
            <div class="capper-padded-4x">
                <div class="rte" v-html="modifiedBody"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GenericText",
    props: {
        json: {
            type: Object,
            required: true,
        },
        allJson: {
            type: Object,
            required: false,
        },
    },
    computed: {
        modifiedBody() {
            // 1) parse the raw HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.json.body, "text/html");

            // 2) iframe title injection
            if (this.allJson?.title) {
                doc.querySelectorAll("iframe").forEach((iframe) => {
                    iframe.setAttribute("title", this.allJson.title);
                });
            }

            // 3) prep primary site URL (no trailing slash)
            if (window.siteConfig?.primarySiteUrl) {
                const primary = window.siteConfig?.primarySiteUrl.replace(/\/$/, "");
                doc.querySelectorAll("a").forEach((a) => {
                    const href = a.getAttribute("href");
                    if (href && !href.startsWith(primary)) {
                        a.setAttribute("target", "_blank");
                    }
                });
            }

            // 5) serialize back to HTML
            return doc.body.innerHTML;
        },
    },
    mounted() {
        this.$refs.contentBlock.addEventListener("click", this.handleLinkClick);
    },
    beforeUnmount() {
        this.$refs.contentBlock.removeEventListener(
            "click",
            this.handleLinkClick
        );
    },
    methods: {
        handleLinkClick(event) {
            let target = event.target;
            while (target && target !== event.currentTarget) {
                if (target.tagName === "A") {
                    const linkTarget = target.getAttribute("target");
                    // only intercept links without a target or with _self
                    if (!linkTarget || linkTarget === "_self") {
                        const href = target.getAttribute("href");
                        if (href) {
                            const slug = href.replace(
                                /^(?:https?:\/\/)?(?:www\.)?[^/]+/,
                                ""
                            );
                            event.preventDefault();
                            this.$router.push(slug);
                            return;
                        }
                    }
                    break;
                }
                target = target.parentNode;
            }
        },
    },
};
</script>
